import axios from "axios";
import store from "@/store";
//import AppConfigs from "@/common/app_configs";
//import { instanceURL } from "@/common/instance";
//import instance from "@/common/instance";
//import { instanceURL } from "@/common/use_instance";
  
//export default axios.create({
//  baseURL: AppConfigs.serverURL,
//  headers: headers
//});

export default function(instance_name) {
  const jwToken = store.getters.jwToken;
  let headers;
  
  if (jwToken) {
    headers = {
      "Content-type": "application/json",
      "Authorization": `Token ${jwToken}`
    }
  } else {
    headers = {
      "Content-type": "application/json"
    }
  }

  instance_name = instance_name ? instance_name : store.getters.currentInstance;
  const base_url = window.location.origin + "/" + instance_name

  return axios.create({
    //baseURL: AppConfigs.serverURL,
    //baseURL: instanceURL(),
    baseURL: base_url,
    headers: headers
  });
}